// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__31R9g","label":"Labeled_label__DIz9Q","divider":"Labeled_divider__1ZCuj"};